export const mutations = {
    SET_FAQ_CATEGORIES: (state, data) => {
        state.faqCategories = data
    },
}